module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"systems":"Systems","serialnumber":"Serial number","footer":"Select Ellipse system serial number from drop down list","buttons":{"credit":"Time/Pulse File","configuration":"Configuration File"}},"da":{"systems":"Systemer","serialnumber":"Serienummer","footer":"Vælg Ellipse system serienummer fra dropdown liste","buttons":{"credit":"Tids-/Pulsfil","configuration":"Konfigurationsfil"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./WebApp/components/Systems.vue
// module id = 590
// module chunks = 0